import type { ResponseErrorClass } from '@app/types/sdk';

interface ProblemDetails {
  title?: string;
  detail?: string;
  message?: string;
  error?: string;
}

export const resolveErrorMessage = async (error: unknown, fallback = 'Something went wrong'): Promise<string> => {
  if (isResponseError(error)) {
    try {
      const data = (await error.response.json()) as ProblemDetails;
      return data.detail ?? data.title ?? data.message ?? data.error ?? `${error.response.status} ${error.response.statusText}`;
    } catch (parseError) {
      console.warn('[error] Failed to parse problem response', parseError);
      return `${error.response.status} ${error.response.statusText}`;
    }
  }

  if (error instanceof Error) {
    return error.message || fallback;
  }

  return fallback;
};

function isResponseError(error: unknown): error is ResponseErrorClass {
  return error instanceof Error && typeof (error as Partial<ResponseErrorClass>).response !== 'undefined';
}
